<template>
  <div>
    <div style="width: 100%; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
        <el-button 
            style="margin-right: 5px;" 
            @click="submit" 
            v-if="($store.getters.getProductionItemIssueDataProps.id>0 
                && checkIfModuleAccessAvailable('/issuerawmaterials', 'can_edit')) 
                    || ($store.getters.getProductionItemIssueDataProps.id === 0 
                        && $store.getters.getAccessRights.can_add)"
            :loading="$store.getters.getLoadingState" 
            type="primary" 
            size="small">Submit</el-button>
        <el-popconfirm
            @confirm="$store.dispatch('deleteProductionItemIssueData', {id: $store.state.productionItemIssue.props.id, navBack: true, store_list: $store.getters.getAccessibleStoreList})"
            title="Are you sure to delete this?"
            >
            <el-button v-if="$store.getters.getProductionItemIssueDataProps.id>0 && $store.getters.getProductionItemIssueDataProps.status === 0 && $store.getters.getAccessRights.can_delete" style="margin-right: 5px;" slot="reference" type="danger" size="small">Delete</el-button>            
        </el-popconfirm>
        <el-button v-if="rowData" size="small" @click="$emit('closed')">Go Back</el-button>
    </div>
    <br>
    <PrintWindow 
        :title="getPrintTitle"
        v-if="isPrintWindowVisible"
        :src="getPrintSrc"
        :dialogVisible="isPrintWindowVisible" 
        @closePrintWindow="showPrintWindow = false" />

    <Basic :rowData="rowData"/>
    
    <ItemList v-if="$store.getters.getProductionItemIssueDataProps.production_id>0 && $store.getters.getProductionItemIssueDataProps.store_id>0" />
    <br><br><br><br>
  </div>
</template>

<script>
import Basic from './Basic.vue'
import ItemList from './ItemList.vue'

export default {
    props: ['rowData'],
    components: { Basic, ItemList },
    data() {
        return {
            showPrintWindow: false,
            printSrc: '',
            printTitle: ''
        }
    },
    computed: {
        getPrintTitle() {
            return this.printTitle
        },
        getPrintSrc() {
            return this.printSrc
        },
        isPrintWindowVisible() {
            return this.showPrintWindow
        }
    },
    methods: {
        submit() {
            let payload = JSON.parse(JSON.stringify(this.$store.getters.getProductionItemIssueDataProps))

            if(payload.sourced_by_staff_id === null 
                || payload.sourced_by_staff_id === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please select the sourcing employee', type: 'Error'})    
                document.getElementById('sourced_by_staff_id').focus()
                return
            } else if(payload.delivered_by_staff_id === null 
                || payload.delivered_by_staff_id === 0) {
                this.$store.commit('displayMessageAlert', {message: 'Please select the employee who delivered', type: 'Error'})    
                document.getElementById('delivered_by_staff_id').focus()
                return
            }
            
            this.$store.dispatch('submitProductionItemIssueData', payload)
        },
        changeStatus(status) {
            this.$store.getters.getProductionItemIssueDataProps.status = status

            setTimeout(() => {
                this.submit()
            }, 300);
        },
        handleDropdownCommand(command) {
            if(command == "printPO") {
                this.printTitle = 'Paper Size: A4'
                this.printSrc = this.master_url+'target=purchaseOrder&subpage=print&purchase_order_id='+this.$store.getters.getProductionItemIssueDataProps.id+'&access_token='+this.$store.getters.getAccessToken
                this.showPrintWindow = true
            } else if(command == "emailPO") {
                this.$confirm('Are you sure to proceed?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.printTitle = 'Processing Mail'
                    this.printSrc = this.master_url+'target=purchaseOrder&subpage=email&purchase_order_id='+this.$store.getters.getProductionItemIssueDataProps.id+'&access_token='+this.$store.getters.getAccessToken
                    this.showPrintWindow = true
                }).catch(() => {
                            
                });
                
            }
        },
        printRcpt() {
            this.printTitle = 'Paper Size: A4'
            this.printSrc = this.master_url+'target=productionItemIssue&subpage=print&sourcing_id='+this.$store.getters.getProductionItemIssueDataProps.id+'&access_token='+this.$store.getters.getAccessToken
            this.showPrintWindow = true            
        }
    },
    mounted() {
        this.$store.dispatch('fetchEmployeeMasterList', {store_list: this.$store.getters.getAccessibleStoreList})  
        
        this.$store.commit('resetProductionItemIssueData')
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/ProductionItemIssue/Index.vue